import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Toolbar/toolbar';
import { css } from '@patternfly/react-styles';
import { ToolbarContentContext, ToolbarContext } from './ToolbarUtils';
import { formatBreakpointMods } from '../../helpers/util';
import { ToolbarExpandableContent } from './ToolbarExpandableContent';
export var ToolbarContent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ToolbarContent, _React$Component);

  function ToolbarContent() {
    var _this;

    _classCallCheck(this, ToolbarContent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToolbarContent).apply(this, arguments));
    _this.expandableContentRef = React.createRef();
    _this.chipContainerRef = React.createRef();
    return _this;
  }

  _createClass(ToolbarContent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          className = _a.className,
          children = _a.children,
          isExpanded = _a.isExpanded,
          toolbarId = _a.toolbarId,
          visiblity = _a.visiblity,
          alignment = _a.alignment,
          clearAllFilters = _a.clearAllFilters,
          showClearFiltersButton = _a.showClearFiltersButton,
          clearFiltersButtonText = _a.clearFiltersButtonText,
          props = __rest(_a, ["className", "children", "isExpanded", "toolbarId", "visiblity", "alignment", "clearAllFilters", "showClearFiltersButton", "clearFiltersButtonText"]);

      return React.createElement("div", Object.assign({
        className: css(styles.toolbarContent, formatBreakpointMods(visiblity, styles), formatBreakpointMods(alignment, styles), className)
      }, props), React.createElement(ToolbarContext.Consumer, null, function (_ref) {
        var clearAllFiltersContext = _ref.clearAllFilters,
            clearFiltersButtonContext = _ref.clearFiltersButtonText,
            showClearFiltersButtonContext = _ref.showClearFiltersButton,
            toolbarIdContext = _ref.toolbarId;
        var expandableContentId = "".concat(toolbarId || toolbarIdContext, "-expandable-content-").concat(ToolbarContent.currentId++);
        return React.createElement(ToolbarContentContext.Provider, {
          value: {
            expandableContentRef: _this2.expandableContentRef,
            expandableContentId: expandableContentId,
            chipContainerRef: _this2.chipContainerRef
          }
        }, React.createElement("div", {
          className: css(styles.toolbarContentSection)
        }, children), React.createElement(ToolbarExpandableContent, {
          id: expandableContentId,
          isExpanded: isExpanded,
          expandableContentRef: _this2.expandableContentRef,
          chipContainerRef: _this2.chipContainerRef,
          clearAllFilters: clearAllFilters || clearAllFiltersContext,
          showClearFiltersButton: showClearFiltersButton || showClearFiltersButtonContext,
          clearFiltersButtonText: clearFiltersButtonText || clearFiltersButtonContext
        }));
      }));
    }
  }]);

  return ToolbarContent;
}(React.Component);
ToolbarContent.currentId = 0;
ToolbarContent.defaultProps = {
  isExpanded: false,
  showClearFiltersButton: false
};